import React from "react";
import NavigationButtons from "@components/common/StepsScreenComponents/NavigationButtons";
import { useTranslation } from "react-i18next";
import MedicalViewMultipSelectDropdown from "@components/ui/customDropdowns/MedicalViewMultipSelectDropdown";
const StepsFrom = ({
  currentStep,
  steps,
  selectedTags,
  setSelectedTags,
  errors,
  setErrors,
  validateStep,
  setCurrentStep,
  loading,
  resetAdviceData,
  validateInput,
  isAdviceLoading,
  handleSubmit,
  handleSelecChange,
  handleInputChange,
  handleMultiSelectChange,
  removeTag,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-center">
      <div className="grid sm:grid-cols-2 gap-0 sm:gap-10 w-full mt-2 md:mt-10">
        <div className="pt-0 md:pt-0 md:p-4 space-y-4">
          <h2 className="text-[20px] md:text-center font-[600] text-black-600 font-[Lato] md:mb-3">
            {steps[currentStep]?.title}
          </h2>
          <p className="text-[#0575E6] text-[16px] md:text-start !mt-2">
            {steps[currentStep]?.subtitle}
          </p>
          {steps[currentStep]?.options?.map(
            ({ label, key, options, type, maxSelection = null }) => {
              if (type !== "country-select") {
                return (
                  <div key={key} className="flex flex-col gap-2 !m-0">
                    <>
                      {label !== "Weight" && (
                        <p className="text-black text-[14px] font-[Lato]">
                          {/* {label} */}
                          {t(`mindfulnessCoachPreferences.fields.${key}`)}
                        </p>
                      )}

                      <div className="relative w-full mr-5">
                        {type === "multi-select" && (
                          <>
                            <MedicalViewMultipSelectDropdown
                              options={options.map((opt) => ({
                                value: opt, // Original value (for internal use)
                                label: t(
                                  `mindfulnessCoachPreferences.options.${key}.${opt}`
                                ), // Translated label (for display)
                              }))}
                              selectedValues={selectedTags[key] || []} // Original values
                              onSelect={(selectedOptions) => {
                                // Extract original values from selected options
                                const originalValues = selectedOptions.map(
                                  (opt) =>
                                    typeof opt === "object" ? opt.value : opt
                                );
                                handleMultiSelectChange(key, originalValues);
                              }}
                              // isFistForm={true}
                              hasError={errors[key]}
                              label={t(
                                `mindfulnessCoachPreferences.fields.${key}`
                              )}
                              placeholder={t("preferences.validation.onlyOne")}
                              isEditable={true}
                              isFistForm={true}
                            />
                          </>
                        )}
                        {type === "select" ? (
                          <>
                            <select
                              className={`border p-2 rounded-md w-[100%] h-10 text-[12px] outline-none bg-white ${
                                errors[key] ? "border-red-500" : ""
                              }`}
                              value={
                                Array.isArray(selectedTags[key])
                                  ? selectedTags[key][
                                      selectedTags[key].length - 1
                                    ]
                                  : selectedTags[key] || ""
                              }
                              onChange={(e) =>
                                handleSelecChange(key, e.target.value)
                              }
                            >
                              <option value="" disabled>
                                {t("preferences.validation.onlyOne")}
                              </option>
                              {options.map((option) => (
                                <option key={option} value={option}>
                                  {t(
                                    `mindfulnessCoachPreferences.options.${key}.${option}`
                                  )}
                                </option>
                              ))}
                            </select>
                            {errors[key] && (
                              <div className="text-red-500 text-[10px] md:text-[12px] ml-2 mt-1">
                                {errors[key]}
                              </div>
                            )}
                          </>
                        ) : type === "numeric" ? (
                          <>
                            {label === "Weight" ? (
                              <>
                                <div className="flex items-center justify-between mb-2">
                                  <p className="text-black text-[16px] ">
                                    {label}
                                  </p>
                                  <div className="flex">
                                    {["kg", "Lbs"].map((unit) => (
                                      <button
                                        key={unit}
                                        onClick={() =>
                                          setSelectedTags((prev) => {
                                            const newUnit = unit;
                                            if (selectedTags.weight) {
                                              const convertedWeight =
                                                newUnit === "Lbs"
                                                  ? prev.weight * 2.20462
                                                  : prev.weight / 2.20462;

                                              return {
                                                ...prev,
                                                weightUnit: newUnit,
                                                weight:
                                                  Math.round(convertedWeight),
                                              };
                                            } else {
                                              return {
                                                ...prev,
                                                weightUnit: newUnit,
                                              };
                                            }
                                          })
                                        }
                                        className={`px-4 py-1 border rounded-md mr-2 text-sm ${
                                          selectedTags.weightUnit === unit
                                            ? "bg-blue-500 text-white"
                                            : "bg-white text-black border-gray-300"
                                        }`}
                                        type="button"
                                        disabled={
                                          unit === selectedTags.weightUnit
                                        }
                                      >
                                        {unit}
                                      </button>
                                    ))}
                                  </div>
                                </div>

                                <input
                                  type="number"
                                  className={`border p-2 rounded-md w-full h-10 text-sm ${
                                    errors[key] ? "border-red-500" : ""
                                  } focus:outline-none`}
                                  min="1"
                                  value={selectedTags[key]}
                                  onChange={(e) =>
                                    handleInputChange(
                                      key,
                                      e.target.value,
                                      label
                                    )
                                  }
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  placeholder={`Enter ${label} in ${selectedTags.weightUnit}`}
                                />
                              </>
                            ) : (
                              <input
                                type="number"
                                className={`border p-2 rounded-md w-full h-10 text-sm ${
                                  errors[key] ? "border-red-500" : ""
                                } focus:outline-none`}
                                value={selectedTags[key]}
                                min="1"
                                onChange={(e) =>
                                  handleInputChange(key, e.target.value, label)
                                }
                                onKeyDown={(e) => {
                                  if (["e", "E", "+", "-"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                placeholder={`Enter ${label}`}
                              />
                            )}
                            {errors[key] && (
                              <div className="text-red-500 text-[10px] md:text-[12px] ml-2 mt-1">
                                {errors[key]}
                              </div>
                            )}
                          </>
                        ) : null}
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {type !== "numeric" && (
                          <>
                            {
                              selectedTags[key] &&
                                Array.isArray(selectedTags[key]) &&
                                selectedTags[key]?.map((tag, index) => (
                                  <span
                                    key={tag}
                                    className="bg-blue-100 text-blue-600 px-2 py-1 rounded-md text-sm flex items-center"
                                  >
                                    {/* {tag} */}
                                    {t(
                                      `mindfulnessCoachPreferences.options.${key}.${tag}`
                                    )}

                                    <button
                                      onClick={() =>
                                        removeTag(key, selectedTags[key][index])
                                      }
                                      className="ml-1 text-blue-400 hover:text-blue-700"
                                    >
                                      ✕
                                    </button>
                                  </span>
                                ))

                            
                            }
                          </>
                        )}
                      </div>
                    </>
                  </div>
                );
              } else {
                return null;
              }
            }
          )}
          <NavigationButtons
            currentStep={currentStep}
            steps={steps}
            loading={loading}
            isAdviceLoading={isAdviceLoading}
            validateStep={validateStep}
            setCurrentStep={setCurrentStep}
            handleSubmit={handleSubmit}
            sleepCoach={false}
            selectedTags={selectedTags}
          />
        </div>

        {steps[currentStep]?.src && (
          <div className="">
            <img
              src={steps[currentStep]?.src}
              alt="stepImage"
              className=" object-cover rounded-[15px] w-full min-h-[500px] max-h-[638px]  hidden sm:block "
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StepsFrom;
